import React from 'react';
import HttpRequestModal from 'react/containers/modals/HttpRequestModal';
import { actionCreators as configHeadersActions } from 'react/api/actions/configEventHttpHeadersModal';
import { CustomProvider, renderComponent } from 'react/utils/renderUtils';

Greenmile.Actions = Greenmile.Actions || {};
Greenmile.Actions.HttpRequest = {
  authenticationFields: [
    {
      key: 'basic-authentication',
      label: 'Basic Authentication',
      el: `
        <div class="headers-item" id="basic-authentication">
          <div class="item-head">
            <h5>Basic Authentication</h5>
            <div class="box-close"></div>
          </div>
          <div class="item-body">
            <div class="input-field">
              <label type="text" for="username">Username*</label>
              <input type="text" autocomplete="new-username" id="username" name="username">
            </div>
            <div class="input-field">
              <label type="text" for="password">Password*</label>
              <input type="password" autocomplete="new-password" id="password" name="password">
            </div>
          </div>
        </div>
      `
    },
    {
      key: 'bearer-token',
      label: 'Bearer Token',
      el: `
        <div class="headers-item" id="bearer-token">
          <div class="item-head">
            <h5>Bearer Token</h5>
            <div class="box-close"></div>
          </div>
          <div class="item-body">
            <div class="input-field">
              <label type="text" for="token">Token*</label>
              <input type="text" id="token" name="token">
            </div>
          </div>
        </div>
      `
    },
    {
      key: 'api-key',
      label: 'API Key',
      el: `
        <div class="headers-item" id="api-key">
          <div class="item-head">
            <h5>API Key</h5>
            <div class="box-close"></div>
          </div>
          <div class="item-body">
            <div class="input-field">
              <label type="text" for="key">Key*</label>
              <input type="text" id="key" name="key">
            </div>
            <div class="input-field">
              <label type="text" for="value">Value*</label>
              <input type="text" id="value" name="value">
            </div>
            <div class="input-field">
              <label type="text" for="addApiKey">Add API Key to</label>
              <select type="text" id="addApiKey" name="addApiKey">
                <option value="header">Header</option>
                <option value="query">Query Params</option>
              </select>
            </div>
          </div>
        </div>
      `
    }
  ],
  defaultAuthMethods: [
    "basic-authentication",
    "bearer-token",
    "api-key"
  ],
  template: () => ({
    tag: 'div',
    items: [
      {
        tag: 'div',
        attributes: {
          class: 'post-request-wrapper'
        },
        items: [
          {
            tag: 'div',
            attributes: {
              class: 'post-request-container'
            },
            items: [
              {
                tag: 'label',
                items: [
                  {
                    tag: 'span',
                    html: 'event.http.url',
                    attributes: {
                      class: 'i18nResource'
                    }
                  }
                ],
                attributes: {
                  class: 'control-label',
                  for: 'action_http_url'
                }
              },
              {
                items: [
                  {
                    tag: 'input',
                    attributes: {
                      type: 'text',
                      maxlength: '150',
                      name: 'action_http_url',
                      id: 'action_http_url',
                      class: 'modelAttribute textField mandatory',
                      autocomplete: 'off'
                    }
                  }
                ],
                attributes: {
                  class: 'controls'
                }
              },
              {
                tag: 'div',
                items: [
                  {
                    tag: 'div',
                    attributes: {
                      class: 'headers-container'
                    },
                    items: [
                      {
                        tag: 'div',
                        attributes: {
                          class: 'headers-buttons'
                        },
                        items: [
                          {
                            tag: 'div',
                            attributes: {
                              class: 'auth-method'
                            },
                            items: [
                              {
                                tag: 'label',
                                html: 'event.postRequestAction.authType.label',
                                attributes: {
                                  class:
                                    'i18nResource dropdown-toggle MonetUIButton btn btn-primary',
                                  title: 'Authentication method',
                                  for: 'authentication-method'
                                }
                              },
                              {
                                tag: 'select',
                                attributes: {
                                  id: 'authentication-method',
                                  name: 'authentication-method'
                                }
                              }
                            ]
                          },
                          {
                            tag: 'button',
                            html: 'event.postRequestAction.modal.title',
                            attributes: {
                              class: 'i18nResource MonetUIButton btn btn-primary',
                              id: 'configure-headers',
                              type: 'button',
                              'data-toggle': 'dropdown',
                              title: 'Configure headers'
                            }
                          }
                        ]
                      },
                      {
                        tag: 'div',
                        attributes: {
                          class: 'headers-list'
                        }
                      }
                    ]
                  }
                ]
              },
              {
                tag: 'label',
                items: [
                  {
                    tag: 'span',
                    html: 'event.http.data',
                    attributes: {
                      class: 'i18nResource'
                    }
                  }
                ],
                attributes: {
                  class: 'control-label',
                  for: 'action_http_data'
                }
              },
              {
                tag: 'div',
                attributes: {
                  id: 'post_request_data'
                },
                items: [
                  {
                    tag: 'textarea',
                    attributes: {
                      autocomplete: 'off',
                      class: 'post_request_data autocomplete_entity',
                      name: 'post_request_data'
                    }
                  },
                  {
                    tag: 'div',
                    attributes: {
                      class: 'post_request_data',
                      id: 'bubbling-mask'
                    }
                  },
                  {
                    tag: 'span',
                    html: 'event.http.data.errorMessageJson',
                    attributes: {
                      class: 'i18nResource'
                    }
                  },
                  {
                    tag: 'div',
                    attributes: {
                      id: 'bubble-button'
                    }
                  },
                ]
              }
            ]
          },
          {
            tag: 'div',
            attributes: {
              class: 'post-request-info',
              display: 'flex'
            },
            items: [
              {
                tag: 'label',
                items: [
                  {
                    tag: 'span',
                    html: 'event.http.url.preview',
                    attributes: {
                      class: 'i18nResource'
                    }
                  }
                ],
                attributes: {
                  class: 'control-label',
                  for: "url-result-wrapper"
                }
              },
              {
                tag: 'pre',
                attributes: {
                  class: 'url-result-wrapper',
                  id: 'url-result-wrapper'
                },
                items: [
                ]
              },
              {
                tag: 'label',
                items: [
                  {
                    tag: 'span',
                    html: 'event.http.headers.preview',
                    attributes: {
                      class: 'i18nResource',
                      id: ''
                    }
                  }
                ],
                attributes: {
                  class: 'control-label',
                  id: 'headers-preview-label',
                  for: "headers-result-wrapper"
                }
              },
              {
                tag: 'pre',
                attributes: {
                  class: 'headers-result-wrapper',
                  id: 'headers-result-wrapper'
                }
              },
            ]
          },
        ]
      }
    ]
  }),

  addListener: function (authenticationMethodFields) {
    let previousIndexSelect = 0;
    const authMethodSelect = $('#authentication-method');
    const btnConfigureHeader = $('#configure-headers');
    const titleText = Monet.I18n.getResourcesByKey('event.postRequestAction.alert.title');
    const url = document.querySelector('#action_http_url');
    const urlPreview = document.querySelector('#url-result-wrapper');
    const messageText = Monet.I18n.getResourcesByKey('event.postRequestAction.alert.message');

    const previewHttpAuthMethodCallback = () => {
      const  { keyInput, valueInput, addKeyTo } = Greenmile.Event.EventActionUtil.getFieldHttpRequestApiKeyMethod();

      const handleEventListenerCreation = () => {
        Greenmile.Event.EventActionUtil.cleanUrlPreview();

        if (addKeyTo.value === 'query') {
          urlPreview.innerHTML = '';
          urlPreview.appendChild(document.createTextNode(`${url.value}/?${key.value}=${value.value}`));
        }
      }
        addKeyTo.addEventListener('change', handleEventListenerCreation);
        keyInput.addEventListener('input', handleEventListenerCreation);
        valueInput.addEventListener('input', handleEventListenerCreation);
    }

    $(authMethodSelect).on('change', ({ target }) => {
      const isDraft = this.checkChangeAuthMethodSelect();
      const confirmClickButton = () => {
        Greenmile.Event.EventActionUtil.cleanUrlPreview();

        this.handleChangeAuthMethodSelect(
          target.value,
          authenticationMethodFields,
          previewHttpAuthMethodCallback
        );
      };
      const cancelClickButton = () => {
        target.selectedIndex = previousIndexSelect;
      };

      if (!isDraft) {
        this.handleChangeAuthMethodSelect(
          target.value,
          authenticationMethodFields,
          previewHttpAuthMethodCallback
        );
        previousIndexSelect = target.selectedIndex;
        return;
      }

      new Greenmile.Components.AlertModal(
        messageText,
        titleText,
        confirmClickButton,
        cancelClickButton
      ).show();
    });

    $(btnConfigureHeader).on('click', () =>
      this.openModalConfigureHeader()
    );
  },
  fillFieldsWithValues: function(fieldsToFill = []) {
    fieldsToFill.forEach(({ field, value, trigger }) => {
      $(field).val(value);
      if(trigger) {
        $(field).trigger(trigger);
      }
    });
  },
  getAuthCredentials: function () {
    const ajax = new Monet.Ajax();
    ajax.url = '/AuthConfig';
    ajax.method = 'GET';
    ajax.success = data => {
      const newMethods = data ?? [];

      const methodsFormatted = newMethods.map(authItem => ({
        key: authItem.id,
        label: authItem.name,
        el: null,
        payload: authItem.type
      }));

      if(methodsFormatted.length > 0) {
        const dividerItem = {
          key: 'divider',
          label: Monet.I18n.getResourcesByKey('event.postRequestAction.select.divider'),
          isDivider: true,
          el: null
        };
        methodsFormatted.unshift(dividerItem);
      }

      const methodsMerged = [
        ...this.authenticationFields,
        ...methodsFormatted
      ];

      this.createAuthMethodSelect(methodsMerged);
      const { crudStage } = App.Forms.Event.form;

      this.addListener(methodsMerged);

      if(crudStage === 'edit') {
        const { authMethodSelected, fieldsToFill } = Monet.Session.Events;
        if(authMethodSelected) {
          $('#authentication-method')
            .val(authMethodSelected)
            .trigger("change");
        }

        if(fieldsToFill) {
          this.fillFieldsWithValues(fieldsToFill)
        }

      }
    };
    ajax.send();
  },
  prepareBodyComponent: function () {
    const eventElement = $('#Event');

    Greenmile.Event.AddAttribute.prepareAddAtribute(
      '#post_request_data',
      '[name="post_request_data"]',
      true
    );

    Greenmile.Event.EventActionUtil.addListenerOnHttpRequestUrlInput();

    if (eventElement) {
      const containerModal = document.createElement('div');
      const containerAlertModal = document.createElement('div');
      containerModal.id = 'httpRequestModalContainer';
      containerAlertModal.id = 'httpRequestAlertModalContainer';

      $(eventElement).append(containerModal, containerAlertModal);

      renderComponent(
        <CustomProvider>
          <HttpRequestModal parentSelector={() => containerModal} />
        </CustomProvider>,
        containerModal
      );
    }

    window.GreenmileReduxStore.dispatch(configHeadersActions.updateHeaders({}));
    this.createAuthMethodSelect(this.authenticationFields);
    this.getAuthCredentials();
  },

  createAuthMethodSelect: function (fields) {
    const defaultOptionTitle =
      Monet.I18n.getResourcesByKey('event.postRequestAction.select.title');
    let selectOptions = `<option value="">${defaultOptionTitle}</option>`;

    $('#authentication-method').empty();
    fields.forEach((option) => {
      const { label, key, isDivider } = option;
      selectOptions += `<option value="${key}" ${isDivider ? 'disabled' : ''}>${label}</option>`;
    });
    $('#authentication-method').append(selectOptions);
  },

  openModalConfigureHeader: function () {
    window.GreenmileReduxStore.dispatch(configHeadersActions.openModal());
  },

  handleChangeAuthMethodSelect: function (currentValue, fields, callback) {
    const headerItem = fields.find(({ key }) => key === currentValue);

    $('.headers-list').empty();

    if (headerItem) {
      const { el: htmlContent } = headerItem;
      $('.headers-list').append(htmlContent);

      $('.box-close').on('click', () => {
        $('.headers-list').empty();
        this.createAuthMethodSelect(fields);
        Greenmile.Event.EventActionUtil.cleanUrlPreview();
      });
    }

    if (currentValue === 'api-key') {
        callback()
    }
  },

  checkChangeAuthMethodSelect: function () {
    const headerItemElement = $('.headers-item');
    const fields = $('.headers-item .item-body input, .headers-item .item-body select');

    if (!headerItemElement) {
      return false;
    }

    const values = [];

    $(fields).each((_, { value }) => value !== '' && values.push(value));

    return Boolean(values.length);
  },

  assignParameter: (jsonParameter) => {
    const param = JSON.parse(jsonParameter);

    if (param) {
      let { url, authConfigurationId } = param;
      const { data, apikey } = param;
      const headers = typeof param.headers === "string" ? JSON.parse(param.headers) : param.headers;

      let authMethodSelected;
      const fieldsToFill = [];

      if(headers?.Authorization) {

        if(headers?.Authorization.includes("Basic")) {
          authMethodSelected = "basic-authentication";
          const basicAuth = headers?.Authorization.replace("Basic", "").trim();
          const userAndPass = Greenmile.CrossBrowserBase64.decode(basicAuth);
          const [user, password] = userAndPass.split(":");

          fieldsToFill.push(
            {
              field: '#username',
              value: user,
            },
            {
              field: '#password',
              value: password
            }
          );
        }

        if(headers?.Authorization.includes("Bearer")) {
          authMethodSelected = "bearer-token";
          const bearerAuth = headers?.Authorization.replace("Bearer", "").trim();

          fieldsToFill.push({ field: "#token", value: bearerAuth });
        }

        delete headers.Authorization;
      }

      if(apikey?.type && !headers?.Authorization) {
        authMethodSelected = "api-key";
        const { key, value } = apikey;

        if(apikey.type === "header") {
          delete headers[key]
          $("#addApiKey").val("header").trigger("change");
          fieldsToFill.push({
            field: '#addApiKey',
            value: 'header',
            trigger: 'change'
          });
        }

        if(apikey.type === "query") {
          const regex = new RegExp(`/[?&]${key}=${value}`, "g");
          url = url.replace(regex, "");
          fieldsToFill.push({
            field: '#addApiKey',
            value: 'query',
            trigger: 'change'
          });
        }

        fieldsToFill.push(
          {
            field: '#key',
            value: key
          },
          {
            field: '#value',
            value: value
          }
        );
      }

      fieldsToFill.push(
        {
          field: '#action_http_url',
          value: url
        },
        {
          field: '#post_request_data > textarea',
          value: data
        }
      );

      if(headers) {
        delete headers["Content-Type"];
      }

      if(authConfigurationId) {
        authMethodSelected = authConfigurationId;
      }

      Monet.Session.Events = {
        authMethodSelected,
        fieldsToFill
      };

      Greenmile.Event.AddAttribute.updateBubblingMask(data, '#post_request_data');
      window.GreenmileReduxStore.dispatch(configHeadersActions.updateHeaders(headers));
    }

  },

  retrieveParameter: function() {
    let url = $('#action_http_url').val();
    const authMethod = $('#authentication-method').val();
    const data = $('#post_request_data > textarea').val();
    const headersStringify = GreenmileReduxStore.getState().configEventHttpHeadersModal.get("headers").toJS();
    const apikey = {};
    const isDefaultAuthMethod = this.defaultAuthMethods.includes(authMethod);

    headersStringify["Content-Type"] = "application/json";

    if(authMethod === "basic-authentication") {
      const user = $("#username").val();
      const pass = $("#password").val();
      const base64 = Greenmile.CrossBrowserBase64.encode(`${user}:${pass}`);
      headersStringify["Authorization"] = `Basic ${base64}`;
    }

    if(authMethod === "bearer-token") {
      const token = $("#token").val();
      headersStringify["Authorization"] = `Bearer ${token}`;
    }

    if(authMethod === "api-key") {
      const key = $("#key").val();
      const value = $("#value").val();
      const addTo = $("#addApiKey").val();
      apikey.key = key;
      apikey.value = value;

      if(addTo === "header") {
        headersStringify[key] = value;
        apikey.type = "header";
      }
      if(addTo === "query") {
        apikey.type = "query";
        url = `${url}/?${key}=${value}`;
      }
    }
    const authConfigurationId = !isDefaultAuthMethod ? authMethod : null;

    const headers = JSON.stringify(headersStringify);
    const request = JSON.stringify({
        url,
        headers,
        data,
        apikey,
        authConfigurationId
    });

    return request;
  }
};
